import { render, staticRenderFns } from "./TelephonyFolderRedirect.vue?vue&type=template&id=ffed0172"
import script from "./TelephonyFolderRedirect.vue?vue&type=script&lang=ts"
export * from "./TelephonyFolderRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports